var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view')],1):_vm._e(),(!_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('tooltip'),_c('alert'),_c('modal'),_c('delete')],1)}
var staticRenderFns = []

export { render, staticRenderFns }